import a from "./index.es298.js";
function t(n) {
  var o = n.schema, e = n.columns;
  if (o || e) {
    var r = (o || e).map(a).join("");
    if (r)
      return "<cols>".concat(r, "</cols>");
  }
  return "";
}
export {
  t as default
};
//# sourceMappingURL=index.es265.js.map
